import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const PartnerProfile = ({ partner }) => {
  return (
    <div className="bg-card rounded-xl shadow-brand border border-border overflow-hidden hover-lift">
      <div className="relative">
        <div className="aspect-[4/5] overflow-hidden">
          <Image
            src={partner?.image}
            alt={partner?.name}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute top-4 right-4">
          <div className="bg-success/10 border border-success/20 rounded-full px-3 py-1 backdrop-blur-sm">
            <span className="text-xs font-medium text-success">
              {partner?.id === 1 ? 'CVA & CPA Certified' : partner?.id === 2 ? 'CVA & FMVA Certified' : 'CVA & CPA Certified'}
            </span>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="mb-4">
          <h3 className="text-xl font-semibold text-text-primary mb-1">
            {partner?.name}
          </h3>
          <p className="text-accent font-medium mb-2">{partner?.title}</p>
          <p className="text-sm text-text-secondary">{partner?.credentials}</p>
        </div>

        <div className="mb-4">
          <p className="text-sm text-text-primary leading-relaxed">
            {partner?.bio}
          </p>
        </div>

        {/* <div className="space-y-3 mb-6">
          <div className="flex items-center text-sm">
            <Icon name="Award" size={16} className="text-accent mr-3 flex-shrink-0" />
            <span className="text-text-secondary">
              <span className="font-medium text-text-primary">{partner?.experience}</span> years of valuation experience
            </span>
          </div>
          
          <div className="flex items-center text-sm">
            <Icon name="Scale" size={16} className="text-accent mr-3 flex-shrink-0" />
            <span className="text-text-secondary">
              <span className="font-medium text-text-primary">{partner?.courtAppearances}</span> court appearances
            </span>
          </div>
          
          <div className="flex items-center text-sm">
            <Icon name="TrendingUp" size={16} className="text-accent mr-3 flex-shrink-0" />
            <span className="text-text-secondary">
              <span className="font-medium text-text-primary">{partner?.valuationsCompleted}</span> valuations completed
            </span>
          </div>
        </div> */}

        <div className="mb-6">
          {/* <h4 className="text-sm font-semibold text-text-primary mb-3">Specializations</h4> */}
          <div className="flex flex-wrap gap-2">
            {partner?.specializations?.map((spec, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-muted text-text-secondary text-xs font-medium rounded-full"
              >
                {spec}
              </span>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center space-x-3">
            <a
              href={partner?.linkedin}
              className="p-2 rounded-lg hover:bg-muted transition-colors duration-200"
              aria-label={`${partner?.name} LinkedIn profile`}
            >
              <Icon name="Linkedin" size={18} className="text-accent" />
            </a>
            <a
              href={`mailto:${partner?.email}`}
              className="p-2 rounded-lg hover:bg-muted transition-colors duration-200"
              aria-label={`Email ${partner?.name}`}
            >
              <Icon name="Mail" size={18} className="text-accent" />
            </a>
          </div>

          {/* <div className="flex items-center text-xs text-text-secondary">
            <Icon name="MapPin" size={14} className="mr-1" />
            {partner?.location}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PartnerProfile;